export default "__VITE_ASSET__UavMz7i9__"